<script>
  import Report from '../../model/report'
  import DataService from './dataService'
  import SectionTabs from '../../model/sectionTabsModel.js'

  export default {
    name: 'speciesOfInterestBaseWrapper',
    computed: {
      reportData () {
        return Report.query().whereId(Report.lockedId).first() || null
      },
      primarySample () {
        return this.reportData?.primarySample || null
      },
      secondarySample () {
        return this.reportData?.secondarySample || null
      },
      distributorConfiguration () {
        return this.reportData?.reportConfiguration || null
      },
      filters () {
        return this.reportData?.filters || []
      },
      categories () {
        return (
          this.reportData?.reportConfiguration?.categories
            ?.speciesOfInterestCategories || null
        )
      },
      tabs () {
        return this.categories.map(tabObject => {
          const labelKey = tabObject.key
          tabObject.label = this.i18n.t(`details.sections.interest.category.${labelKey}.label`)
          tabObject.subLabel = this.i18n.t(`details.sections.interest.category.${labelKey}.subLabel`)
          return new SectionTabs(tabObject)
        })
      },
      activeTab () {
        return this.categories.find((category) =>
          this.selectedCategory
            ? category.key === this.selectedCategory?.key
            : category.defaultSelected === true
        )
      },
      containsMultipleSamples () {
        return Boolean(
          this.primarySample?.identifier && this.secondarySample?.identifier
        )
      }
    },
    data () {
      return {
        selectedCategory: null,
        collapseAll: null,
        data: null,
        healthAssociation: {
          goodHealth: true,
          poorHealth: true,
          noHealth: true
        }
      }
    },
    mounted () {
      this.fetchData()
    },
    methods: {
      isActiveTab (tabKey) {
        return this.activeTab?.key === tabKey
      },
      fetchData () {
        const dataService = new DataService(
          this.distributorConfiguration,
          this.primarySample,
          this.secondarySample
        )
        this.data = dataService.getGenusSpeciesData()
      }
    }
  }
</script>
